<template>
  <div>
    <div v-if="order">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <h3>
            <button class="btn btn-xs btn-success pull-right" data-toggle="modal" data-target="#add-link-order" v-if="user.admin"><i class="fa fa-edit"></i> Edit</button>
            {{ order.name }}
          </h3>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Client</td>
                  <td>
                    <select ref="client" @change="updateClient" class="col-lg-12 form-control" v-if="user.admin && order.client">
                      <option :value="client.id" v-for="client in f.clients" :key="client.id" :selected="order.client && client.id === order.client.id">{{ client.name }}</option>
                    </select>
                    <span v-else><strong v-if="order.client">{{ order.client.name }}</strong></span>
                  </td>
                </tr>
                <tr>
                  <td>Group</td>
                  <td>
                    <select ref="group" @change="updateGroup" class="col-lg-12 form-control" v-if="user.admin && order.group">
                      <option value="null">No Group</option>
                      <option :value="group.id" v-for="group in f.groups" :key="group.id" :selected="order.group && group.id === order.group.id">{{ group.client.name }} - {{ group.name }}</option>
                    </select>
                    <span v-else><strong v-if="order.group">{{ order.group ? order.group.name : '/' }}</strong></span>
                  </td>
                </tr>
                <tr>
                  <td>Category</td>
                  <td>
                    <e-txt
                      type="select"
                      :options="f.categories"
                      @input="updateProperty($event, 'category')"
                      close-on-save="true"></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="order.status"
                      :options="['open', 'completed']"
                      @input="updateProperty($event, 'status')"
                      close-on-save="true"
                      :locked="!user.admin"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Added</td>
                  <td>{{ order.added && order.added.date ? $moment(order.added.date).format('DD.MM.YYYY') : '/' }}</td>
                </tr>
                <tr>
                  <td>Deadline</td>
                  <td>{{ order.deadline && order.deadline.date ? $moment(order.deadline.date).format('DD.MM.YYYY') : '/' }}</td>
                </tr>
                <tr>
                  <td>Placements</td>
                  <td>{{ order.linksCompleted }} / {{ order.number }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    {{ order.description }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs" v-if="user.admin">
                <thead>
                <tr>
                  <th>
                    Links
                    <a class="collapse-link pull-right" data-toggle="collapse" aria-controls="colTargets" href="#colTargets">
                      <i class="fa fa-chevron-down"></i>
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <ol class="collapse" id="colTargets">
                      <li v-for="(target, i) in order.targets" :key="'target-' + i"><span :style="target.completed ? 'font-weight: bold' : ''">{{ target.url }} [{{ target.anchor }}]</span></li>
                    </ol>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="col-md-6" v-if="user.admin">
            <table class="table small m-b-xs" v-if="order.source">
              <thead>
              <tr>
                <th colspan="2">Sources</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Language:</td>
                <td>
                  {{ getLang(order.language) }}
                </td>
              </tr>
              <tr>
                <td>Backup Language:</td>
                <td>
                  {{ getLang(order.backupLang) }}
                </td>
              </tr>
              <tr>
                <td>Clients:</td>
                <td>
                  <span class="label label-primary m-xs" v-for="(c, i) in order.source.clients" :key="'client-' + i">{{ c.name }}</span>
                </td>
              </tr>
              <tr>
                <td>Groups:</td>
                <td>
                  <span class="label label-success m-xs" v-for="(g, i) in order.source.groups" :key="'group-' + i">{{ g.name }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../../Helpers/Form/EditText'
import axios from 'axios'
import { ORDER_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      order: 'getLinkOrder',
      f: 'getFilters',
      user: 'getUser',
      languages: 'getLanguages'
    })
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loaded = true
    document.title = 'Link Building Order :: PBN360 by Aphex Media'
  },
  methods: {
    updateClient () {
      prompt('Pick a number between 1 and 70')
      alert('no, fuck off, the correct answer was something else!')
    },
    updateGroup () {
      prompt('Pick a color')
      alert('omg, no, go away.')
    },
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val
      axios.patch(`/pbn/links/order/${this.order.id}`, data)
        .then(r => {
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$store.commit(ORDER_SET, r.data.order)
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })
    },
    getLang (lang) {
      if (!lang) return '/'
      return this.languages.filter(l => l.index === lang)[0].label
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order/Header.vue